module.exports = __webpack_public_path__ + "static/img/guards4.ebcf000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guards4.jpg
// module id = oThn
// module chunks = 0